import Vue from 'vue';
import commonScripts from './common';
import newsletter from './partials/newsletter';
import audioPlayer from './partials/audio_player';
import dotationForm from './partials/dotationBoxForm';

commonScripts();
audioPlayer();
dotationForm();
// run article footer newsletter form
const article_newsletter = document.querySelector('.article__newsletter');
if (article_newsletter) {
	new Vue({
		el: '.article__newsletter',
		delimiters: ['${', '}'],
		mixins: [newsletter]
	});
}

// run article aside newsletter form
const aside_newsletter = document.querySelector('#asideNewsletter');
if (aside_newsletter) {
	new Vue({
		el: '#asideNewsletter',
		delimiters: ['${', '}'],
		mixins: [newsletter]
	});
}

//sticky aside
const aside = document.querySelector('.article_row__aside:not(.article_row__aside--dotation)');

if (aside) {
	const asidePoint = aside.offsetTop;
	let asideX = aside.offsetLeft;

	if (document.querySelector('.article_row__aside-body') && (document.querySelector('.article_row__aside-body').offsetHeight < document.querySelector('.article').offsetHeight)){
    const endPoint = document.querySelector('.footer').offsetTop - 48 - document.querySelector('.article_row__aside-body').offsetHeight - 24;

    window.addEventListener('resize', () => {
      const scrollY = window.scrollY;

      asideX = document.querySelector('.article').offsetLeft + document.querySelector('.article').offsetWidth + 30;

      console.log(aside.offsetLeft)

      if (scrollY > asidePoint) {
        aside.style.left = asideX + 'px';
      } else {
        aside.style.left = 0;
      }
    });

    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;

      let topOffset = scrollY - endPoint;

      if (scrollY > asidePoint) {
        aside.style.left = asideX + 'px';
        aside.classList.add('isFixed');
      } else {
        aside.style.left = 0;
        aside.classList.remove('isFixed');
      }

      if (scrollY > endPoint) {
        aside.style.top = -topOffset + 'px';
      } else {
        aside.style.top = 0;
      }
    });
  }
}


// WEBPACK FOOTER //
// ./assets/js/article.js